import isNil from "lodash/isNil";
import { LayerDefinitionDc } from "@evergis/api";

import { SchemaParsed } from "../../../../evergis/core/import/parseSchema";

export const getLayerDefinition = (items: SchemaParsed["children"]) => {
  let result: LayerDefinitionDc;

  items.some(item => {
    if (!isNil(item.layerDefinition)) {
      result = item.layerDefinition;

      return true;
    }

    if (item.children?.length) {
      result = getLayerDefinition(item.children);

      return !!result;
    }
  });

  return result;
};
